import React, { useEffect, useState } from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";

import AllLicences from "./licencework/AllLicences";
import CCKitHelper from "./licencework/CCKitHelper";
import CommonlyUsedLicences from "./licencework/CommonlyUsedLicences";
import EasyTrans from "../bundel/EasyTrans";
import { FormBlock, PageContainer } from "../ui";

const TABS = [
  { key: "common", label: "RegisterWork.License.CommonUsedTitle" },
  { key: "kit", label: "RegisterWork.License.LicenseKit.Title" },
  { key: "all", label: "RegisterWork.License.AllLicensesTitle" },
];

const RegisterWorkLicence = (props) => {
  const [tab, setTab] = useState("common");
  const [licenses, setLicenses] = useState([]);

  useEffect(() => {
    fetch(
      "https://raw.githubusercontent.com/spdx/license-list-data/master/json/licenses.json",
    )
      .then((value) => value.json())
      .then((jsonValue) => setLicenses(jsonValue.licenses))
      .catch((e) => console.error(e));
  }, []);

  return (
    <PageContainer>
      <div className="mt-10 sm:mt-0">
        <FormBlock
          title={<EasyTrans>RegisterWork.Title.AddLicence</EasyTrans>}
          description={<EasyTrans>RegisterWork.Title.AddLicenceCaption</EasyTrans>}
        >
          <div className="space-y-5">
            {/* tabs */}
            <div className="grid grid-cols-3 gap-1 rounded-lg bg-gray-100 p-1">
              {TABS.map((tb) => (
                <button
                  key={tb.key}
                  type="button"
                  onClick={() => setTab(tb.key)}
                  className={`rounded-md px-3 py-2 text-sm transition ${
                    tab === tb.key
                      ? "bg-white font-medium text-fairblue-700 shadow-sm"
                      : "text-gray-500 hover:text-gray-800"
                  }`}
                >
                  <EasyTrans>{tb.label}</EasyTrans>
                </button>
              ))}
            </div>

            {/* tab content */}
            <div className="rounded-xl border border-gray-200 p-4">
              {tab === "common" && (
                <CommonlyUsedLicences
                  workType={props.workType}
                  onSetLicence={props.onSetLicence}
                  licences={licenses}
                  licenceError={props.licenceError}
                  setLicenceError={props.setLicenceError}
                />
              )}
              {tab === "kit" && (
                <CCKitHelper
                  onSetLicence={props.onSetLicence}
                  licenceError={props.licenceError}
                  setLicenceError={props.setLicenceError}
                />
              )}
              {tab === "all" && (
                <AllLicences
                  onSetLicence={props.onSetLicence}
                  licences={licenses}
                  licence={props.licence}
                  licenceError={props.licenceError}
                  setLicenceError={props.setLicenceError}
                />
              )}
            </div>

            {/* selected license */}
            {props.licence ? (
              <div className="flex items-center gap-2 rounded-xl border border-fairdarkgreen/40 bg-fairdarkgreen/5 p-3">
                <CheckCircleIcon
                  className="h-5 w-5 flex-shrink-0 text-fairdarkgreen"
                  aria-hidden="true"
                />
                <span className="text-sm text-gray-700">
                  <EasyTrans>RegisterWork.License.CommonSelected</EasyTrans>:{" "}
                  <span className="font-semibold text-gray-900">
                    {props.licence}
                  </span>
                </span>
              </div>
            ) : (
              <div
                className={`rounded-xl border p-3 text-sm ${
                  props.licenceError
                    ? "border-red-300 bg-red-50 text-red-700"
                    : "border-gray-200 text-gray-500"
                }`}
              >
                <EasyTrans>RegisterWork.License.CommonSelectLicense</EasyTrans>
                <span className="text-red-600">*</span>
              </div>
            )}
          </div>
        </FormBlock>
      </div>

      <div className="hidden sm:block" aria-hidden="true">
        <div className="py-5">
          <div className="border-t border-gray-200" />
        </div>
      </div>
    </PageContainer>
  );
};

export default RegisterWorkLicence;
